export const LS_USER_PREFERENCES_KEY = 'aiMateUserPreferences';
